import { render, staticRenderFns } from "./supplygrade.vue?vue&type=template&id=acc5cd8c&scoped=true&"
import script from "./supplygrade.vue?vue&type=script&lang=js&"
export * from "./supplygrade.vue?vue&type=script&lang=js&"
import style0 from "./supplygrade.vue?vue&type=style&index=0&id=acc5cd8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc5cd8c",
  null
  
)

export default component.exports